export const STORAGE_KEYS = {
  AUTH: 'auth',
  APP: 'compliance-desk',
}

export const ENDPOINTS = {
  LOGIN: 'api/login',
  LOGOUT: 'auth/logout',
  REFRESH: 'auth/refresh',
  ME: 'me',
  EMPLOYEE_ACCESS_INVITATION_PREVIEW: 'api/public/employee-access-invitations/{token}',
  EMPLOYEE_ACCESS_INVITATION_ACCEPT: 'api/public/employee-access-invitations/{token}/accept',
  EMPLOYEE_ACCESS_INVITATION_REJECT: 'api/public/employee-access-invitations/{token}/reject',
}
